import ThemedComponent from '../../../hoc/ThemedComponent';
import NewsPromoList from './NewsPromoList';
import NewsPromoList4 from '../../../themes/4/components/News/NewsPromoList';

const ThemedNewsListItem = {
    default: NewsPromoList,
    // 4: NewsPromoList4
};

export default ThemedComponent(ThemedNewsListItem);